import { string, func, arrayOf, shape } from 'prop-types';
import styled from 'styled-components';
import ReactAutocomplete from 'react-autocomplete';
import Input from './input';

const AutocompleteItem = styled.div`
  line-height: 1;
  padding: 0.75rem;
  background-color: ${({highlighted}) => highlighted ? 'rgba(195, 226, 245, 0.3)' : 'inherit'};
  color: ${({theme}) => theme.colors.text_dark};

  &:hover {
    background-color: rgba(195, 226, 245, 0.3);
  }
`;

const AutocompleteMenu = styled.div`
  position: absolute;
  left: 0;
  top: 3em;
  width: 100%;
  background-color: ${({theme}) => theme.colors.bg_white};
  border: 1px solid ${({theme}) => theme.colors.brand_blue};
  z-index: 25;
  user-select: none;
  border-radius: 0;
  padding: 0.25rem 0;
`;

function AutoComplete ({id, items, input, meta, onChange, onSelect }) {
  return (
    <ReactAutocomplete
      items={items}
      getItemValue={item => item.label}
      renderItem={(item, highlighted) =>
        <AutocompleteItem key={item.id} highlighted={highlighted}>
          {item.label}
        </AutocompleteItem>
      }
      renderInput={props => <Input id={id} {...props} {...meta}  />}
      wrapperStyle={{
        position: 'relative',
        width: '100%',
      }}
      renderMenu={(items, value) => {
        return items.length > 0 ? <AutocompleteMenu children={items}/> : <div />;
      }}
      {...input}
      onChange={e => onChange(e.target.value)}
      onSelect={(value, item) => onSelect(item)}
    />
  );
}

AutoComplete.propTypes = {
  id: string.isRequired,
  items: arrayOf(shape({})).isRequired,
  input: shape({}).isRequired,
  meta: shape({}).isRequired,
  onChange: func.isRequired,
  onSelect: func.isRequired,
}

export default AutoComplete;